import { useState } from "react";
import { animeList } from "@/mocks/anime";
import type { Anime } from "@/mocks/anime";

export default function Roam() {
  const [current, setCurrent] = useState<Anime | null>(null);
  const [history, setHistory] = useState<string[]>([]);

  const roam = () => {
    let next = Math.floor(Math.random() * animeList.length);
    if (current) {
      let guard = 0;
      while (animeList[next].id === current.id && guard < 20) {
        next = Math.floor(Math.random() * animeList.length);
        guard += 1;
      }
    }
    const picked = animeList[next];
    setCurrent(picked);
    setHistory((h) => (h.includes(picked.title) ? h : [...h, picked.title].slice(-8)));
  };

  return (
    <section id="roam" className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dreamy%20anime%20illustration%20of%20a%20swirling%20warm%20cosmic%20portal%20made%20of%20coral%20orange%20and%20gold%20light%2C%20floating%20anime%20story%20scenes%20drifting%20through%20a%20glowing%20sky%2C%20magical%20random%20exploration%20feeling%2C%20light%20particles%2C%20stylized%20anime%20background%20art%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=roam-bg&orientation=landscape"
        alt="随缘漫游 暖色系梦幻光流动漫背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>

      <div className="relative z-10 mx-auto max-w-5xl px-4 md:px-6 text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm font-semibold px-4 py-1.5 mb-4">
          <i className="ri-compass-3-line"></i>
          随缘漫游
        </p>
        <h2 className="font-heading text-3xl md:text-5xl text-white">随缘漫游 · 交给命运</h2>
        <p className="mt-3 md:mt-5 text-white/90 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
          不需要做任何选择。点一下，小缘就从片库里为你翻出下一部。告别选择困难，每次刷新都有新发现。
        </p>

        <button
          type="button"
          onClick={roam}
          className="mt-7 md:mt-9 inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-base md:text-lg font-bold px-9 py-4 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-shuffle-line"></i>
          {current ? "再漫游一次" : "开始随缘漫游"}
        </button>

        {current ? (
          <div className="mt-9 md:mt-11 mx-auto max-w-2xl rounded-3xl overflow-hidden bg-background-50/95 backdrop-blur-sm text-left shadow-sm">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-2/5">
                <img
                  src={current.image}
                  alt={`随缘漫游翻到的番剧：${current.title}`}
                  className="w-full h-52 sm:h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 p-5 md:p-7">
                <div className="flex flex-wrap items-center gap-2">
                  {current.tags.map((t) => (
                    <span key={t} className="rounded-full bg-primary-100 text-primary-700 text-xs px-3 py-1">
                      {t}
                    </span>
                  ))}
                </div>
                <h3 className="mt-3 font-heading text-2xl text-foreground-950">{current.title}</h3>
                <p className="mt-1 text-xs text-foreground-600">
                  {current.year}年 · {current.episodes} · {current.studio} ·{" "}
                  <i className="ri-star-fill text-accent-500 mr-0.5"></i>
                  {current.score}
                </p>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed line-clamp-3">{current.synopsis}</p>
              </div>
            </div>
          </div>
        ) : (
          <p className="mt-8 text-white/75 text-sm">
            <i className="ri-sparkling-2-line mr-1"></i>
            点下按钮，命运开始漫游……
          </p>
        )}

        {history.length > 0 && (
          <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
            <span className="inline-flex items-center gap-1 text-white/75 text-xs mr-1 whitespace-nowrap">
              <i className="ri-map-pin-2-line"></i>
              漫游足迹：
            </span>
            {history.map((h) => (
              <span key={h} className="rounded-full bg-background-50/15 border border-white/20 text-white/90 text-xs px-3 py-1.5">
                {h}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}